import _useMount from 'react-use/esm/useMount';
import {notify} from '@gemcook/notification';

import utils from '@utils';
import {UseMount} from './types';

export const useMount: UseMount = (props, actions) => {
  const id = utils.pathParams.getUserId(props.location.pathname);

  _useMount(async () => {
    try {
      if (props.history.action !== 'PUSH') {
        await actions.users.getOneUser(id);
      }
    } catch (error) {
      notify(error.message, 'error');
    }
  });
};
